import PropTypes from 'prop-types';
import {
    Box,
    CircularProgress,
    LinearProgress,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { Chart } from '../../components/chart';

const useChartOptions = (labels) => {
    const theme = useTheme();

    return {
        chart: {
            background: 'transparent'
        },
        colors: [
            theme.palette.success.main,
            theme.palette.warning.main,
            theme.palette.error.main
        ],
        dataLabels: {
            enabled: false
        },
        labels,
        legend: {
            show: false
        },
        plotOptions: {
            pie: {
                expandOnClick: false
            }
        },
        states: {
            active: {
                filter: {
                    type: 'none'
                }
            },
            hover: {
                filter: {
                    type: 'none'
                }
            }
        },
        stroke: {
            width: 0
        },
        theme: {
            mode: theme.palette.mode
        },
        tooltip: {
            fillSeriesColor: false
        }
    };
};

export const OrdersPieChart = (props) => {
    const { chartSeries, labels, deliveryRates, isLoading } = props;
    const chartOptions = useChartOptions(labels);

    return (
        <>
            {isLoading &&
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 365
                }}>
                    <CircularProgress
                        sx={{
                            mx: 'auto',
                            my: 3,
                        }}
                    />
                </Box>
            }
            {!isLoading &&
                <>
                    <Chart
                        height={300}
                        options={chartOptions}
                        series={chartSeries}
                        type="donut"
                        width="100%"
                    />
                    {deliveryRates.map((item, index) => (
                        <Stack
                            key={index}
                            direction="row"
                            sx={{ alignItems: 'center', gap: 2, pb: 2 }}
                        >
                            <Stack sx={{ gap: 1, flexGrow: 1 }}>
                                <Stack
                                    direction="row"
                                    sx={{
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        gap: 2,
                                    }}
                                >
                                    <Typography variant="body2" sx={{ fontWeight: '500' }}>
                                        {item.label}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {item.value}%
                                    </Typography>
                                </Stack>
                                <LinearProgress
                                    variant="determinate"
                                    aria-label="Number of percentage"
                                    value={item.value}
                                    color={item.value < 50 ? 'error' : item.value < 75 ? 'warning' : 'success'}
                                />
                            </Stack>
                        </Stack>
                    ))}
                </>
            }
        </>
    );
};

OrdersPieChart.propTypes = {
    chartSeries: PropTypes.array.isRequired,
    labels: PropTypes.array.isRequired,
    sx: PropTypes.object
};